@if (isRequestHeaderUiEnhancementEnabled()) {
  <div class="flex flex-col p-md gap-md">
    @if (!showSideDetails()) {
      @for (tab of tabs(); track tab.id; let index = $index) {
        <div class="relative">
          <button
            (click)="onTabChanged(index)"
            title="{{ tab.title | transloco }}"
            class="flex items-center justify-center size-10 px-md border border-neutral-300 rounded-lg bg-white hover:bg-neutral-50 transition-colors cursor-pointer">
            <ng-container
              [ngTemplateOutlet]="tabIcon"
              [ngTemplateOutletContext]="{ $implicit: tab }" />
          </button>

          @if (tab.id === TAB_IDS.DISCUSSION && showUnreadMessagesIndicator()) {
            <span
              class="h-[0.5rem] w-[0.5rem] bg-destructive-500 rounded-full absolute top-[0.1rem] end-[0.1rem]"></span>
          }
        </div>
      }
    } @else {
      <div class="w-full">
        <div class="flex justify-between items-center p-lg">
          <p class="text-neutral-900 text-lg font-bold">
            {{ offCanvasTitle() | transloco }}
          </p>

          <a
            class="border border-neutral-200 rounded-md cursor-pointer size-10 flex justify-center items-center"
            (click)="closeDetailsSidebar.emit()">
            <lib-close-icon iconClass="size-6 text-neutral-900" />
          </a>
        </div>

        <ng-container [ngTemplateOutlet]="actionTabsTemplate" />
      </div>
    }
  </div>
} @else {
  <div class="flex gap-md">
    @for (tab of tabs(); track tab.id; let index = $index) {
      <div class="relative">
        <button
          (click)="onTabChanged(index)"
          class="flex items-center gap-sm text-sm font-medium text-neutral-900 px-lg py-sm border border-neutral-300 rounded-sm">
          <ng-container
            [ngTemplateOutlet]="tabIcon"
            [ngTemplateOutletContext]="{ $implicit: tab }" />
          {{ tab.title | transloco }}
        </button>

        @if (tab.id === TAB_IDS.DISCUSSION && showUnreadMessagesIndicator()) {
          <span
            class="h-[0.75rem] w-[0.75rem] bg-destructive-500 rounded-full absolute top-[-0.2rem] end-[-0.2rem]"></span>
        }
      </div>
    }
  </div>
}

@if (!isRequestHeaderUiEnhancementEnabled() && showSideDetails()) {
  <lib-off-canvas
    [title]="offCanvasTitle() | transloco"
    [offCanvasContentClass]="'h-screen overflow-hidden'"
    (hide)="closeDetailsSidebar.emit()"
    [turnOffOutSideClick]="turnOffOutSideClick()">
    <ng-container [ngTemplateOutlet]="actionTabsTemplate" />
  </lib-off-canvas>
}

<ng-template #actionTabsTemplate>
  <lib-tabs
    [tabsBorder]="true"
    [activeTabIndex]="activeTabIndex()"
    (selectTab)="onTabChanged($event)">
    @for (tab of tabs(); track tab.id) {
      <lib-tab [tabTitle]="tab.title | transloco" #tabTemplate>
        @if (tabTemplate.active()) {
          <ng-container
            [ngTemplateOutlet]="tabContent"
            [ngTemplateOutletContext]="{ $implicit: tab }" />
        }
      </lib-tab>
    }

    <ng-template #tabContent let-tab>
      @switch (tab.id) {
        @case (TAB_IDS.CONTRIBUTORS) {
          <lib-request-contributors [flowId]="flowId().toString() || ''" />
        }
        @case (TAB_IDS.DETAILS) {
          <lib-request-view-details
            [requestDetailsResponse]="offCanvasRequestDetailsResponse()" />
        }
        @case (TAB_IDS.DISCUSSION) {
          <lib-request-discussion
            [flowId]="flowId().toString() || ''"
            [newComment]="newComment()"
            [deletedCommentId]="deletedCommentId()"
            (turnOffOutSideClick)="handleTurnOffOutSideClick($event)" />
        }
        @case (TAB_IDS.ATTACHMENTS) {
          <lib-request-discussion
            [flowId]="flowId().toString() || ''"
            [newComment]="newComment()"
            [showAttachmentsOnly]="true"
            (turnOffOutSideClick)="turnOffOutSideClick.set($event)" />
        }
      }
    </ng-template>
  </lib-tabs>
</ng-template>

<ng-template #tabIcon let-tab>
  @switch (tab.id) {
    @case (TAB_IDS.CONTRIBUTORS) {
      <lib-contributors-icon iconClass="size-5 text-neutral-900" />
    }
    @case (TAB_IDS.DETAILS) {
      <lib-info-icon iconClass="size-5 text-neutral-900" />
    }
    @case (TAB_IDS.DISCUSSION) {
      <lib-chat-icon iconClass="size-5 text-neutral-900" />
    }
    @case (TAB_IDS.ATTACHMENTS) {
      <lib-attachment-icon iconClass="size-5 text-neutral-900" />
    }
  }
</ng-template>
